module.exports = __webpack_public_path__ + "img/mum-and-girl.014ddfa3.png";